import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { interval, Subject, Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UserService } from 'src/app/services/user.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent implements OnInit, OnDestroy {
  timer!: Subscription;
  currentTime!: number;
  expiredTime!: number;
  countdownTimer: any;
  destroy = new Subject<void>();
  lang: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
    private userService: UserService,
    private cd: ChangeDetectorRef
  ) {
    this.cd.detach();
    this.translate.onDefaultLangChange
    .pipe(takeUntil(this.destroy))
    .subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;
      this.cd.detectChanges();
    });

  }

  ngOnInit(): void {
    let token = this.localStorageService.get(LocalStorage.token);
    if (token && this.data.is_expired_token) {
      this.countdown();
    }
    this.cd.detectChanges();
  }


  countdown() {
    this.expiredTime = Number(this.localStorageService.get(LocalStorage.expiry_time));
    this.timer = interval(1000)
    .subscribe(() => {
      // get current time in seconds
      this.currentTime = Date.now() / 1000;

      // Find the distance between now and the expire date
      let distance = this.expiredTime - this.currentTime;

      // Time calculations for minutes and seconds
      let minutes = Math.floor(distance / 60);
      let seconds = Math.floor(distance % 60);

      // Display format
      let F_min = minutes.toString().length == 1 ? '0' + minutes : minutes;
      let F_sec = seconds.toString().length == 1 ? '0' + seconds : seconds;

      this.countdownTimer = F_min + ':' + F_sec;

      if (minutes <= 0 && seconds <= 0) {
        this.offTimer();
        this.dialog.closeAll();
        this.userService.logout();
      }
      this.cd.detectChanges();
    });
  }

  offTimer() {
    this.timer.unsubscribe();
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
